import React from 'react';
import { Container, SectionTitle } from '../../../components/ui';

export default function LocationSection() {
  return (
    <section id="location" className="py-16 bg-am-green-50">
      <Container>
        <SectionTitle title="Lokasi Kami" align="center" titleClassName="text-am-accent" className="mb-6" />
        <div className="w-full rounded-lg overflow-hidden shadow-lg">
          <iframe
            title="Lokasi Amanmart Kranggan"
            src="https://www.google.com/maps?q=Amanmart%20Kranggan&output=embed"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </Container>
    </section>
  );
}
